// extracted by mini-css-extract-plugin
module.exports = {"split-content":"split_content_split-content__4_AOj"};